import { print } from 'graphql'
import { Cart } from 'shopify-types'

import { storefrontClient } from '..'
import {
  UpdateCartGiftCardCodesDocument,
  type UpdateCartGiftCardCodesMutation,
} from '../__generated/storefront'
import { GlobalRequestOptions } from '../types'
import { mapGQLCartToCart } from './graphql'

export const applyGiftCard =
  (options: GlobalRequestOptions) =>
  async (cartId: string, giftCardCodes: string[]): Promise<Cart> => {
    const response = await storefrontClient.request<UpdateCartGiftCardCodesMutation>(
      print(UpdateCartGiftCardCodesDocument),
      {
        variables: {
          cartId,
          giftCardCodes,
          language: options.language,
        },
      },
    )

    const payload = response.data?.cartGiftCardCodesUpdate

    if (!payload?.cart) {
      throw new Error('Failed to apply giftcard code')
    }

    return mapGQLCartToCart(payload.cart)
  }
